// extracted by mini-css-extract-plugin
export default {"facebookBtn":"FacebookSignInButton_facebookBtn__ozc+-","icon":"FacebookSignInButton_icon__eU9yP","title":"FacebookSignInButton_title__WDfki"};